import { useEffect } from 'react'
// noinspection JSFileReferences
import BulletinPopup from '@kakao/bzm-lounge-bulletin-optin/dist/bulletin-popup.umd.min.js'
import {
  LOUNGE_BOARD_PHASE,
  LOUNGE_BOARD_SERVICE_TYPE,
} from '../loungeBoardContants'

const useLoungeBoardOptInPopup = () => {
  useEffect(() => {
    BulletinPopup.create(LOUNGE_BOARD_SERVICE_TYPE, LOUNGE_BOARD_PHASE).open()
  }, [])
}
export default useLoungeBoardOptInPopup
